import _ from 'lodash';

const buildParams = (params = {}) => {
  const result = new URLSearchParams();
  const keys = Object.keys(params);

  if (keys.includes('page') || keys.includes('limit')) {
    result.append('page[limit]',  params.limit);
    result.append('page[skip]', (params.page || 0) * params.limit);
  }

  keys.forEach(_key => {
    const key = _.snakeCase(_key);
    if (key !== 'page' && key !== 'limit') {
      if (typeof params[key] === 'object') {
        // console.log('found object parameter: ' + key);
        Object.keys(params[key]).forEach(objectKey => {
          let ok = objectKey;
          if (ok.match(/\./)) {
            ok = ok.split('.')
              .map(part => _.snakeCase(part))
              .join('.');
          } else {
            ok = _.snakeCase(objectKey);
          }
          let value = params[ key ][ objectKey ];
          if (objectKey === 'waitTime') {
            ok = 'created_at';
            value = value * -1;
          }
          if (Array.isArray(value)) {
            if (!_.isEmpty(value)) {
              const finalKey = `${ key }[${ ok }]`;
              value.forEach(
                val => {
                  result.append(finalKey, val);
                }
              );
            }
          } else {
            // console.log({ [`${ key }[${ ok }]`]: value });
            result.append(`${ key }[${ ok }]`, value);
          }
        });
      } else {
        result.append(key, params[key]);
      }
    }
  });
  // console.log({ result, params });
  return result;
};

export default (params = { params: {}, token: undefined }) => {
  return {
    params: buildParams(params.params)
  };
};